import api from './client';

export async function login(email: string, password: string) {
  const res = await api.post('/auth/login', { email, password });
  return res.data;
}

export async function loginAs(uid: string): Promise<string> {
  const { data } = await api.post('/auth/login_as', { uid });
  return data.token;
}

export async function forgotPassword(email: string): Promise<{ message: string }> {
  const { data } = await api.post('/auth/forgot-password', { email });
  return data;
}

export interface SignInMethods {
  has_password: boolean;
  social_providers: string[]; // e.g. ["google.com"] / ["apple.com"]
}

// How an email's account can sign in. Resolved server-side (Admin SDK) because
// the client-side fetchSignInMethodsForEmail returns nothing under Firebase
// email-enumeration protection. Used by the login screen to steer a
// social-only user to the right button on a failed password attempt.
export async function getSignInMethods(email: string): Promise<SignInMethods> {
  const { data } = await api.post('/auth/sign-in-methods', { email });
  return data as SignInMethods;
}
